interface IProps {
  fill: number;
  total: number;
  progressColor?: string;
  trackColor?: string;
  height?: string;
  classes?: string;
}

export const FormProgress = ({
  fill,
  total,
  progressColor = "primary",
  trackColor = "gray-50", // Removed square brackets
  height = "h-7",
  classes = "w-full"
}: IProps) => {
  return (
    <div className={`${classes} bg-${trackColor} ${height} rounded-lg overflow-hidden`}>
      <div
        className={`bg-${progressColor} text-xs leading-none ${height} text-center text-white transition-all ease-out duration-500 flex justify-center items-center font-bold`}
        style={{
          width: `${(fill / total) * 100}%`
        }}
      >
        {fill ? `${Math.floor((fill / total) * 100)}%` : null}
      </div>
    </div>
  );
};
